import { render, staticRenderFns } from "./WeekNavigator.vue?vue&type=template&id=92b713ae&scoped=true&"
import script from "./WeekNavigator.vue?vue&type=script&lang=js&"
export * from "./WeekNavigator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b713ae",
  null
  
)

export default component.exports